import Axios from './APIService';
import { AxiosPromise } from 'axios';

import Tag from '@/types/Tag';

const admin = '/admin';

const apiBase = '/tags';

const TagAPI = {

    getTags(): AxiosPromise<Tag[]> {
        return Axios.get(apiBase);
    },

    getTag(tagId: string): AxiosPromise<Tag> {
        return Axios.get(`${admin}${apiBase}/${tagId}`);
    },

    postTag(tag: Tag): AxiosPromise<Tag> {
        return Axios.post(`${admin}${apiBase}`, tag);
    },

    updateTagText(tagId: string, tag: Tag): AxiosPromise<Tag> {
        return Axios.put(`${admin}${apiBase}/${tagId}`, tag);
    },

    delete(tagId: string): AxiosPromise<Tag> {
        return Axios.delete(`${admin}${apiBase}/${tagId}`);
    },

    putAssociatedId(tagId: string, associatedId: string): AxiosPromise<Tag> {
        return Axios.put(`${admin}${apiBase}/${tagId}/associatedIds?associatedId=${associatedId}`);
    },

    deleteAssociatedId(tagId: string, associatedId: string): AxiosPromise<Tag> {
        return Axios.delete(`${admin}${apiBase}/${tagId}/associatedIds/${associatedId}`);
    }

};

export default TagAPI;
